// The React context object + read-side hooks (useLang/useT), split out of
// LanguageContext.jsx so components that need translation but must NOT pull
// in firebase (e.g. ScenarioTimeline.jsx/ZoneLayer.js/ScenarioMatrix.jsx,
// reachable from scenarioCardGrid.js's import graph, which
// scenarioCardGrid.test.js imports directly under jsdom — firebase/auth
// breaks there) can import this module instead of LanguageContext.jsx.
// LanguageContext.jsx imports LanguageContext from here for its Provider,
// and re-exports useLang/useT so every existing import path keeps working
// unchanged.
import { createContext, useCallback, useContext } from 'react';
import { translate } from './translate';
import it from '../locales/it.json';
import en from '../locales/en.json';

const DICTS = { it, en };

// No provider (unit tests rendering a component alone) = legacy Italian, so
// existing tests asserting Italian copy keep passing unchanged.
export const LanguageContext = createContext({ lang: 'it', setLang: () => {}, dateLocale: 'it-IT' });

export const useLang = () => useContext(LanguageContext);

export function useT() {
  const { lang } = useLang();
  return useCallback((key, vars) => translate(DICTS, lang, key, vars), [lang]);
}
